const stagedAmountDisplayComponentDefinition = {
    template: require('./staged-amount-display.component.html').trim(),
    bindings: {
        payingAmount: '<',
        showDescription: '<',
    },
};

module.exports = {
    stagedAmountDisplayComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/digitalpay/staged-amount-display.component.js